import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import '../../buttons/enums.js';
import { isRTL } from '../../../utilities/dom-helpers/index.js';

const buildClassList = (props) => {
    const classes = [
        props.mainClass,
        props.type,
        props.style ? `style-${props.style}` : '',
        props.size ? `size-${props.size}` : '',
        props.mobileInverted ? 'mobile-inverted' : '',
        props.mobileWhite ? 'mobileWhite' : '',
        props.rtl || isRTL() ? 'rtl' : '',
        props.disabled ? 'disabled' : '',
    ];
    return classes.filter(Boolean).join(' ');
};
const renderContent = (props) => {
    const iconTemplate = props.icon
        ? x `<img loading="lazy" src="${props.icon.src}" alt="${props.icon.alt}">`
        : null;
    if (props.iconLeft) {
        return x `${iconTemplate} <span>${props.text}</span>`;
    }
    return x `<span>${props.text}</span> ${iconTemplate}`;
};
const renderInteractiveElement = (props) => {
    const { isAnchor, disabled, href, target, ariaLabel, text, tabindex, type, ariaPressed, ariaExpanded, } = props;
    const classes = buildClassList(props);
    const content = renderContent(props);
    if (isAnchor) {
        return x `<a class="${classes}" href="${href !== null && href !== void 0 ? href : '#'}" target="${l(target)}" aria-label="${ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : text}" role="button" aria-disabled="${l(disabled)}" tabindex="${tabindex !== null && tabindex !== void 0 ? tabindex : 0}" aria-pressed="${l(ariaPressed)}" aria-expanded="${l(ariaExpanded)}">${content}</a>`;
    }
    return x `<button class="${classes}" type="${l(type)}" aria-label="${ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : text}" ?disabled="${disabled}" tabindex="${tabindex !== null && tabindex !== void 0 ? tabindex : 0}" aria-disabled="${l(disabled)}" aria-pressed="${l(ariaPressed)}" aria-expanded="${l(ariaExpanded)}">${content}</button>`;
};

export { renderInteractiveElement };
